import {removeAllFrom} from './collections';



export class EventEmitter {
  constructor () {
    this.listeners = {};
  }
  addListener (eventName, handler) {
    if (!(eventName in this.listeners)) {
      this.listeners[eventName] = [];
    }
    this.listeners[eventName].push(handler);
    return handler;
  }
  removeListener (eventName, handler) {
    if ( eventName in this.listeners ) {
      removeAllFrom(handler, this.listeners[eventName]);
    }
  }
  emit (eventName, ...eventArgs) {
    if ( eventName in this.listeners ) {
      let handlers = this.listeners[eventName];
      for ( let handler of handlers )  {
        handler(...eventArgs);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./lib/rlink-utils/events.js